export default __webpack_public_path__ + "static/media/img-0006.e4d26dba.png";